"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotShield = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotShield = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#C9DBFE",
  d: "M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  stroke: "#13126C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.2,
  d: "m25.678 14.427-7.803 7.626-3.546-3.466m19.006-1.995c0 8.664-5.111 16.482-13.334 20.074-8.222-3.592-13.333-11.41-13.333-20.074v-9.93c9.556-4.438 18.222-4.438 26.667 0v9.93Z"
}));
exports.SpotShield = SpotShield;
SpotShield.displayName = "SpotShield";